<template>
  <div class="container">
    <div>
      <slot></slot>
    </div>
  </div>
</template>